import React, { useState, useEffect, useMemo } from "react";
import {
	Layout,
	Card,
	Tag,
	Typography,
	Button,
	Row,
	Col,
	Input,
	Space,
	Tooltip,
	Spin,
} from "antd";
import {
	ArrowLeftOutlined,
	ShareAltOutlined,
	SearchOutlined,
} from "@ant-design/icons";
import "antd/dist/reset.css";
import { ApiConnector } from "../axios/apiClient";
import {
	CLASS_SECTION,
	FETCH_SHARED_PLAYLIST_WITH_TEACHER,
	PLAYLISTPUBLISHED,
} from "../axios/AllBaseUrl";
import FlagLocalhost from "../Localhost/FlagLocalhost";
import { ViewPlaylist } from "../redux/reducers/PlaylistSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import ColapsableList from "../components/MyPlaylist/Newplaylistui/ColapsableList";
import Publish from "../components/svg/Publish";
import CustomToast from "../utlis/toast/CustomToast";
import PlaylistPublishedModal from "../components/modal/PlaylistPublishedModal";
import AddFloatingButton from "../components/MyPlaylist/AddFloatingButton";

const { Header, Content } = Layout;
const { Title } = Typography;

// Default education-themed playlist cover
const DEFAULT_COVER =
	"https://i.pinimg.com/736x/64/55/bc/6455bcff8f21c24ce77ab54f610782d9.jpg";

const ShareTeacherPlaylist = () => {
	const localData = FlagLocalhost();
	const [playlists, setPlaylists] = useState<any[]>([]);
	const dispatch = useDispatch();
	const playlistReduxData: any = useSelector(
		(state: RootState) => state.playlist
	);

	const [selected, setSelected] = useState(null);
	const [search, setSearch] = useState("");
	const [loading, setLoading] = useState(true);
	let [startTime, setStartTime] = useState<string>("");
	// console.log("startTime", startTime);

	let [endTime, setEndTime] = useState<any>("");
	let [startDate, setStartDate] = useState<any>("");
	let [endDate, setEndDate] = useState<any>("");
	let [questionTimeCheckedStatus, setQuestionTimeCheckedStatus] =
		useState<boolean>(true);
	let [playlistTime, setPlaylistTime] = useState<number>(0);
	const [publishmodal, setPublishmodal] = useState(false);
	const [playlistID, setPlaylistID] = useState();
	let [selectClass, setSelectClass] = useState<any>([{}]);
	let [classId, setClassId] = useState<string>("");
	let [selectSection, setSelectSection] = useState<any>([{}]);
	let [sectionId, setSectionId] = useState<any>("");

	const fetchPlaylistByUserId = async () => {
		try {
			setLoading(true);
			let res = await ApiConnector(
				"post",
				FETCH_SHARED_PLAYLIST_WITH_TEACHER,
				{
					user_id: Number(localData?.user_id),
				}
			);
			if (res?.data?.ok) {
				setLoading(false);
				setPlaylists(res?.data?.data);
			}
		} catch (error) {
			setLoading(false);
			console.error(error);
		}
	};
	const playlistGetId = (playlist) => {
		setSelected(playlist);
		dispatch(ViewPlaylist(playlist?.playlist_id));
	};

	// Fetch playlists from API
	useEffect(() => {
		fetchPlaylistByUserId();
	}, []);

	// Memoized filtered playlists for smooth search
	const filtered = useMemo(() => {
		return playlists?.filter((p) =>
			p?.playlist_name?.toLowerCase().includes(search.toLowerCase())
		);
	}, [playlists, search]);

	const Published = (id, timeData) => {
		setStartTime("");
		setEndTime("");
		setEndDate("");
		setStartDate("");
		setPlaylistTime(timeData);
		setPlaylistID(id);
		setSelectClass([{}]);
		setSelectSection([{}]);
		setSectionId("");

		// setPublishmodal(true);
		if (localData?.isFromEvidya === 1 && id) {
			setPublishmodal(true);
		} else {
			CustomToast("warning", "Published For our Teacher's Only ");
		}
	};
	const publishCancel = () => {
		setStartTime("");
		setEndTime("");
		setEndDate("");
		setStartDate("");
		setSelectClass([{}]);
		setSelectSection([{}]);
		setSectionId([]);
		setPublishmodal(false);
	};
	const Playlistpublish = async () => {
		setSelectClass([{}]);
		setSelectSection([{}]);
		setSectionId("");
		setPublishmodal(false);

		let res = await ApiConnector("post", `${PLAYLISTPUBLISHED}`, {
			playlist_id: playlistID,
			class_id: classId,
			section_id: sectionId,
			// subject_id: "3",
			school_id: localData.school_id,
			academic_year_id: localData.academic_year_id,
			teacher_id: localData.user_id,
			start_date: startDate,
			end_date: endDate,
			start_time: startTime,
			end_time: endTime,
			time_check: questionTimeCheckedStatus ? 1 : 0,
		});
		// console.log(" playlist publish res", res);

		if (res?.data?.ok) {
			CustomToast("success", "Published Successfully");
		} else {
			CustomToast("error", "Published Failed");
		}
	};
	let classIdSet = (e) => {
		setSelectSection([{}]);
		setSectionId("");
		setClassId(e.target.value);
	};
	let sectionIdSet = (e) => {
		setSectionId(e.target.value);
	};

	const handleEndTime = (e) => {
		setEndTime(e);
	};
	const handleStartTime = (e) => {
		setStartTime(e);
	};
	let fetchClass = async () => {
		try {
			setSelectClass([{}]);
			setSelectSection([{}]);
			setSectionId("");
			let res = await ApiConnector("post", `${CLASS_SECTION}`, {
				schoolId: localData?.school_id,
				userId: localData?.user_id,
				userTypeId: localData?.user_type_id,
				// schoolId: "81",
				// userId: "43",
				// userTypeId: "4",
			});
			if (res?.data?.ok) {
				setSelectClass(res?.data?.data?.data);
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		setQuestionTimeCheckedStatus(true);
		setSelectClass([{}]);
		setSelectSection([{}]);
		setSectionId("");
		setClassId("");
		if (localData?.isFromEvidya === 1 && publishmodal) {
			fetchClass();
		}
	}, [publishmodal]);
	useEffect(() => {
		if (playlistTime === 0) {
			setQuestionTimeCheckedStatus(false);
		}
		setSelectSection([{}]);
		setSectionId("");
		if (localData?.isFromEvidya === 1) {
			if (classId) {
				setSelectSection([{}]);
				setSectionId("");
				selectClass?.map((elm, index) => {
					if (classId == elm.id) {
						setSelectSection(elm.mappedSections);
					}
				});
			}
		}
	}, [publishmodal, classId]);
	// Question View
	const QuestionView = ({ playlist }) => (
		<div style={{ padding: 20 }}>
			<Button
				icon={<ArrowLeftOutlined />}
				onClick={() => setSelected(null)}
				type="text"
				style={{
					marginBottom: 20,
					color: "#1677ff",
					fontWeight: 500,
				}}
			>
				Back to Playlists
			</Button>

			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: 16,
					alignItems: "center",
				}}
			>
				<div
					style={{
						width: "100%",
						maxWidth: 800,
						borderRadius: 12,
						background: "linear-gradient(135deg,#eef7fb,#fef6ff)",
						boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
						padding: 24,
					}}
				>
					<Title level={4} style={{ marginBottom: 10 }}>
						{playlist?.playlist_name}
					</Title>
					<p>
						Full Marks: {playlist?.full_marks} | Time:{" "}
						{playlist?.playlist_time}
					</p>
					<Space wrap size={[4, 8]} style={{ marginBottom: 16 }}>
						{playlist?.tag?.map((t) => (
							<Tag color="blue" key={t}>
								{t}
							</Tag>
						))}
					</Space>

					{/* Collapsible Card */}
					{/* <QuestionCollapsibleCard questions={playlist?.questions} /> */}
					{playlistReduxData?.loading && <Spin />}
					{!playlistReduxData?.loading &&
						playlistReduxData?.playlistQuestions?.q_array?.map(
							(value, index) => (
								<ColapsableList key={index} value={value} />
							)
						)}
				</div>
			</div>
		</div>
	);

	return (
		<Layout
			style={{
				minHeight: "100vh",
				background: "linear-gradient(180deg,#f9f9f9,#f0f3ff)",
			}}
		>
			<Header
				style={{
					background: "linear-gradient(90deg, #6380f4ff, #a2c9f2ff)",
					padding: "12px 20px",
					display: "flex",
					alignItems: "center",
				}}
			>
				<Title level={4} style={{ color: "#fff", margin: 0 }}>
					Shared Playlists
				</Title>
			</Header>

			<Content style={{ padding: 20 }}>
				{!selected ? (
					<>
						<div style={{ padding: 20 }}>
							<Input
								placeholder="Search playlist..."
								prefix={<SearchOutlined />}
								value={search}
								onChange={(e) => setSearch(e.target.value)}
								style={{
									marginBottom: 20,
									borderRadius: 8,
									maxWidth: 400,
									boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
								}}
							/>

							{loading ? (
								<div
									style={{
										textAlign: "center",
										marginTop: 50,
									}}
								>
									<Spin size="large" />
								</div>
							) : (
								<Row gutter={[24, 24]}>
									{filtered?.length === 0 && !loading && (
										<Col span={24}>
											<div
												style={{
													textAlign: "center",
													marginTop: 50,
												}}
											>
												<Title level={4}>
													No playlist found
												</Title>
											</div>
										</Col>
									)}
									{filtered?.map((playlist) => (
										<Col
											xs={24}
											sm={12}
											md={8}
											lg={6}
											key={playlist.id}
										>
											<Card
												hoverable
												cover={
													<div
														style={{
															height: 180,
															backgroundImage: `url(${
																playlist?.playlist_img ||
																DEFAULT_COVER
															})`,
															backgroundSize:
																"cover",
															backgroundPosition:
																"center",
															borderTopLeftRadius: 10,
															borderTopRightRadius: 10,
															transition:
																"transform 0.3s ease",
														}}
													/>
												}
												onClick={() =>
													playlistGetId(playlist)
												}
												style={{
													borderRadius: 12,
													overflow: "hidden",
													background:
														"linear-gradient(135deg, #f0f4ff, #fef6ff)",
													boxShadow:
														"0 4px 12px rgba(0,0,0,0.08)",
													cursor: "pointer",
													transition: "all 0.3s ease",
												}}
												bodyStyle={{ padding: 16 }}
											>
												<Space
													align="start"
													style={{
														justifyContent:
															"space-between",
														width: "100%",
													}}
												>
													<div>
														<Title
															level={5}
															style={{
																margin: 0,
															}}
														>
															{
																playlist?.playlist_name
															}
														</Title>
														<Space
															wrap
															size={[4, 8]}
															style={{
																marginTop: 8,
															}}
														>
															<Tooltip
																title={
																	<>
																		{/* */}
																		<p>
																			Total
																			Questions:
																			{
																				playlist
																					?.questions
																					?.length
																			}
																		</p>
																		<p>
																			Full
																			Marks:
																			{
																				playlist?.full_marks
																			}
																		</p>
																		<p>
																			Time
																			limit:
																			{
																				playlist?.playlist_time
																			}
																		</p>
																		<>
																			<p>
																				Tag:{" "}
																			</p>
																			{playlist?.tag?.map(
																				(
																					value,
																					i
																				) => {
																					return (
																						<Tag
																							color="processing"
																							key={
																								i
																							}
																						>
																							{
																								value
																							}
																						</Tag>
																					);
																				}
																			)}
																		</>
																	</>
																}
															>
																{playlist?.tag
																	?.slice(
																		0,
																		3
																	)
																	?.map(
																		(
																			tag
																		) => (
																			<Tag
																				key={
																					tag
																				}
																				color="blue"
																			>
																				{
																					tag
																				}
																			</Tag>
																		)
																	)}
																{playlist?.tag
																	.length >
																	3 && (
																	<Tag>
																		+
																		{playlist
																			.tag
																			.length -
																			3}
																	</Tag>
																)}
															</Tooltip>
														</Space>
													</div>
													<Tooltip
														placement="top"
														title="Published Playlist"
													>
														<Button
															icon={<Publish />}
															type="text"
															onClick={(e) => {
																e.stopPropagation();
																Published(
																	playlist.playlist_id,
																	playlist?.playlist_time
																);
															}}
															style={{
																color: "#1677ff",
															}}
														/>
													</Tooltip>
												</Space>
											</Card>
										</Col>
									))}
								</Row>
							)}
						</div>
					</>
				) : (
					<QuestionView playlist={selected} />
				)}
			</Content>
			<PlaylistPublishedModal
				publishmodal={publishmodal}
				publishCancel={publishCancel}
				Playlistpublish={Playlistpublish}
				classIdSet={classIdSet}
				classId={classId}
				selectClass={selectClass}
				sectionIdSet={sectionIdSet}
				selectSection={selectSection}
				sectionId={sectionId}
				startDate={startDate}
				setStartDate={setStartDate}
				setEndDate={setEndDate}
				startTime={startTime}
				setStartTime={setStartTime}
				setEndTime={setEndTime}
				handleEndTime={handleEndTime}
				handleStartTime={handleStartTime}
				endTime={endTime}
				endDate={endDate}
				questionTimeCheckedStatus={questionTimeCheckedStatus}
				setQuestionTimeCheckedStatus={setQuestionTimeCheckedStatus}
				playlistTime={playlistTime}
			/>

			<Row
				gutter={[24, 0]}
				style={{ position: "fixed", bottom: "4vh", right: "4vw" }}
			>
				{localData?.isFromEvidya === 1 && <AddFloatingButton />}
			</Row>
		</Layout>
	);
};

export default ShareTeacherPlaylist;
